import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BenchmarkPopup = loadAsyncComponent(() => import('./Container'), 'popup');
